
import React, { useRef, useState } from "react";
import { DocumentDashboardDTO, PatientHistoryItemDTO } from "../../../../../api/DashboardWidgetDTO";
import { useMediaQuery, TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, Avatar, IconButton, Typography, Dialog, DialogTitle, DialogContent, DialogActions, Button, useTheme, Box } from "@mui/material";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { REACT_APP_PUBLIC_API_URL } from "../../../../../KeyVariables";
import { handleDownload } from "./AnalyzisArchive";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import FileOpenIcon from '@mui/icons-material/FileOpen';

export interface DICOMArchiveProps {
  items: PatientHistoryItemDTO[];
}

export const DICOMArchive = ({ items }: DICOMArchiveProps) => {
  const { t }: { t: any } = useTranslation('Portal');
  const iframeRef = useRef(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  console.log(items)
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>{t('Portal_CommonDate')}</TableCell>
            <TableCell>{t('Portal_CommonDoctor')}</TableCell>
            <TableCell>{t('Portal_CommonName')}</TableCell>
            <TableCell>{t('Portal_Images')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.length > 0 ? (
            items.map((item, index) => (
              <TableRow key={index}>
                <TableCell>{item.date ? format(item.date, "dd.MM.yyyy HH:mm") : "-"}</TableCell>
                <TableCell>
                  {item.doctorDashboard?.image && (
                    <Avatar src={`${REACT_APP_PUBLIC_API_URL}/image/${item.doctorDashboard.image}`} sx={{ mr: 1 }} />
                  )}
                  {item.doctorDashboard?.name || "-"}
                </TableCell>
                <TableCell>{item.serviceDashboard?.name || "-"}</TableCell>
                <TableCell>
                  {item.images?.length! > 0 ? (
                    <Box display="flex" flexWrap="wrap" mt={1} justifyContent={"left"} gap={1}>
                      {item.images!.map((image, index) => (
                        <Avatar onClick={() => image.link ? window.open(image.link, '_self') : console.log("No link for this image")}
                          key={index} src={REACT_APP_PUBLIC_API_URL + "/image/" + image.identity!} sx={{ width: 70, height: 70, cursor: "pointer" }} />
                      ))}
                    </Box>
                  ) : (
                    "-"
                  )}
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={5} align="center">
                <Typography>{t('Portal_NoDicom')}</Typography>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
